import { j as B } from "./jsx-runtime.DGlMoOmv.js";
import * as Ee from "react";
import o, { useLayoutEffect as xe, useEffect as Kt, useMemo as Gt, createContext as Jt, useContext as Mt, forwardRef as mt, useState as Ce } from "react";
import { T as Oe, C as $e, D as Ae, P as Me, b as Ne, R as Pe, a as Ie, O as _e, F as He } from "./X24.CNnx-_EL.js";
import { c as nt } from "./index.CxSWpsOB.js";
function ke(t) {
  if (typeof document > "u") return;
  let n = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
  e.type = "text/css", n.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
const Qt = o.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), wt = () => {
  const t = o.useContext(Qt);
  if (!t)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return t;
};
ke(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Le() {
  const t = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(t) && /Mobile/.test(t) || // Android Firefox
  /FxiOS/.test(t));
}
function Be() {
  return Nt(/^Mac/);
}
function je() {
  return Nt(/^iPhone/);
}
function Vt() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Fe() {
  return Nt(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Be() && navigator.maxTouchPoints > 1;
}
function Zt() {
  return je() || Fe();
}
function Nt(t) {
  return typeof window < "u" && window.navigator != null ? t.test(window.navigator.platform) : void 0;
}
const Ue = 24, We = typeof window < "u" ? xe : Kt;
function Yt(...t) {
  return (...n) => {
    for (let e of t)
      typeof e == "function" && e(...n);
  };
}
const Et = typeof document < "u" && window.visualViewport;
function qt(t) {
  let n = window.getComputedStyle(t);
  return /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
}
function te(t) {
  for (qt(t) && (t = t.parentElement); t && !qt(t); )
    t = t.parentElement;
  return t || document.scrollingElement || document.documentElement;
}
const ze = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let vt = 0, xt;
function Ve(t = {}) {
  let { isDisabled: n } = t;
  We(() => {
    if (!n)
      return vt++, vt === 1 && Zt() && (xt = Ye()), () => {
        vt--, vt === 0 && xt?.();
      };
  }, [
    n
  ]);
}
function Ye() {
  let t, n = 0, e = (m) => {
    t = te(m.target), !(t === document.documentElement && t === document.body) && (n = m.changedTouches[0].pageY);
  }, r = (m) => {
    if (!t || t === document.documentElement || t === document.body) {
      m.preventDefault();
      return;
    }
    let w = m.changedTouches[0].pageY, j = t.scrollTop, k = t.scrollHeight - t.clientHeight;
    k !== 0 && ((j <= 0 && w > n || j >= k && w < n) && m.preventDefault(), n = w);
  }, i = (m) => {
    let w = m.target;
    $_t(w) && w !== document.activeElement && (m.preventDefault(), w.style.transform = "translateY(-2000px)", w.focus(), requestAnimationFrame(() => {
      w.style.transform = "";
    }));
  }, a = (m) => {
    let w = m.target;
    $_t(w) && (w.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      w.style.transform = "", Et && (Et.height < window.innerHeight ? requestAnimationFrame(() => {
        Xt(w);
      }) : Et.addEventListener("resize", () => Xt(w), {
        once: !0
      }));
    }));
  }, f = () => {
    window.scrollTo(0, 0);
  }, h = window.pageXOffset, S = window.pageYOffset, R = Yt(qe(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let g = Yt(dt(document, "touchstart", e, {
    passive: !1,
    capture: !0
  }), dt(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), dt(document, "touchend", i, {
    passive: !1,
    capture: !0
  }), dt(document, "focus", a, !0), dt(window, "scroll", f));
  return () => {
    R(), g(), window.scrollTo(h, S);
  };
}
function qe(t, n, e) {
  let r = t.style[n];
  return t.style[n] = e, () => {
    t.style[n] = r;
  };
}
function dt(t, n, e, r) {
  return t.addEventListener(n, e, r), () => {
    t.removeEventListener(n, e, r);
  };
}
function Xt(t) {
  let n = document.scrollingElement || document.documentElement;
  for (; t && t !== n; ) {
    let e = te(t);
    if (e !== document.documentElement && e !== document.body && e !== t) {
      let r = e.getBoundingClientRect().top, i = t.getBoundingClientRect().top, a = t.getBoundingClientRect().bottom;
      const f = e.getBoundingClientRect().bottom + Ue;
      a > f && (e.scrollTop += i - r);
    }
    t = e.parentElement;
  }
}
function $_t(t) {
  return t instanceof HTMLInputElement && !ze.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
function Xe(t, n) {
  typeof t == "function" ? t(n) : t != null && (t.current = n);
}
function Ke(...t) {
  return (n) => t.forEach((e) => Xe(e, n));
}
function ee(...t) {
  return Ee.useCallback(Ke(...t), t);
}
const ne = /* @__PURE__ */ new WeakMap();
function $(t, n, e = !1) {
  if (!t || !(t instanceof HTMLElement)) return;
  let r = {};
  Object.entries(n).forEach(([i, a]) => {
    if (i.startsWith("--")) {
      t.style.setProperty(i, a);
      return;
    }
    r[i] = t.style[i], t.style[i] = a;
  }), !e && ne.set(t, r);
}
function Ge(t, n) {
  if (!t || !(t instanceof HTMLElement)) return;
  let e = ne.get(t);
  e && (t.style[n] = e[n]);
}
const O = (t) => {
  switch (t) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return t;
  }
};
function yt(t, n) {
  if (!t)
    return null;
  const e = window.getComputedStyle(t), r = (
    // @ts-ignore
    e.transform || e.webkitTransform || e.mozTransform
  );
  let i = r.match(/^matrix3d\((.+)\)$/);
  return i ? parseFloat(i[1].split(", ")[O(n) ? 13 : 12]) : (i = r.match(/^matrix\((.+)\)$/), i ? parseFloat(i[1].split(", ")[O(n) ? 5 : 4]) : null);
}
function Je(t) {
  return 8 * (Math.log(t + 1) - 2);
}
function Ct(t, n) {
  if (!t) return () => {
  };
  const e = t.style.cssText;
  return Object.assign(t.style, n), () => {
    t.style.cssText = e;
  };
}
function Qe(...t) {
  return (...n) => {
    for (const e of t)
      typeof e == "function" && e(...n);
  };
}
const x = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, re = 0.4, Ze = 0.25, tn = 100, ae = 8, et = 16, At = 26, Ot = "vaul-dragging";
function oe(t) {
  const n = o.useRef(t);
  return o.useEffect(() => {
    n.current = t;
  }), o.useMemo(() => (...e) => n.current == null ? void 0 : n.current.call(n, ...e), []);
}
function en({ defaultProp: t, onChange: n }) {
  const e = o.useState(t), [r] = e, i = o.useRef(r), a = oe(n);
  return o.useEffect(() => {
    i.current !== r && (a(r), i.current = r);
  }, [
    r,
    i,
    a
  ]), e;
}
function ie({ prop: t, defaultProp: n, onChange: e = () => {
} }) {
  const [r, i] = en({
    defaultProp: n,
    onChange: e
  }), a = t !== void 0, f = a ? t : r, h = oe(e), S = o.useCallback((R) => {
    if (a) {
      const m = typeof R == "function" ? R(t) : R;
      m !== t && h(m);
    } else
      i(R);
  }, [
    a,
    t,
    i,
    h
  ]);
  return [
    f,
    S
  ];
}
function nn({ activeSnapPointProp: t, setActiveSnapPointProp: n, snapPoints: e, drawerRef: r, overlayRef: i, fadeFromIndex: a, onSnapPointChange: f, direction: h = "bottom", container: S, snapToSequentialPoint: R }) {
  const [g, m] = ie({
    prop: t,
    defaultProp: e?.[0],
    onChange: n
  }), [w, j] = o.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  o.useEffect(() => {
    function u() {
      j({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", u), () => window.removeEventListener("resize", u);
  }, []);
  const k = o.useMemo(() => g === e?.[e.length - 1] || null, [
    e,
    g
  ]), E = o.useMemo(() => {
    var u;
    return (u = e?.findIndex((b) => b === g)) != null ? u : null;
  }, [
    e,
    g
  ]), F = e && e.length > 0 && (a || a === 0) && !Number.isNaN(a) && e[a] === g || !e, p = o.useMemo(() => {
    const u = S ? {
      width: S.getBoundingClientRect().width,
      height: S.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var b;
    return (b = e?.map((y) => {
      const I = typeof y == "string";
      let N = 0;
      if (I && (N = parseInt(y, 10)), O(h)) {
        const l = I ? N : w ? y * u.height : 0;
        return w ? h === "bottom" ? u.height - l : -u.height + l : l;
      }
      const W = I ? N : w ? y * u.width : 0;
      return w ? h === "right" ? u.width - W : -u.width + W : W;
    })) != null ? b : [];
  }, [
    e,
    w,
    S
  ]), M = o.useMemo(() => E !== null ? p?.[E] : null, [
    p,
    E
  ]), A = o.useCallback((u) => {
    var b;
    const y = (b = p?.findIndex((I) => I === u)) != null ? b : null;
    f(y), $(r.current, {
      transition: `transform ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`,
      transform: O(h) ? `translate3d(0, ${u}px, 0)` : `translate3d(${u}px, 0, 0)`
    }), p && y !== p.length - 1 && a !== void 0 && y !== a && y < a ? $(i.current, {
      transition: `opacity ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`,
      opacity: "0"
    }) : $(i.current, {
      transition: `opacity ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`,
      opacity: "1"
    }), m(e?.[Math.max(y, 0)]);
  }, [
    r.current,
    e,
    p,
    a,
    i,
    m
  ]);
  o.useEffect(() => {
    if (g || t) {
      var u;
      const b = (u = e?.findIndex((y) => y === t || y === g)) != null ? u : -1;
      p && b !== -1 && typeof p[b] == "number" && A(p[b]);
    }
  }, [
    g,
    t,
    e,
    p,
    A
  ]);
  function c({ draggedDistance: u, closeDrawer: b, velocity: y, dismissible: I }) {
    if (a === void 0) return;
    const N = h === "bottom" || h === "right" ? (M ?? 0) - u : (M ?? 0) + u, W = E === a - 1, l = E === 0, U = u > 0;
    if (W && $(i.current, {
      transition: `opacity ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`
    }), !R && y > 2 && !U) {
      I ? b() : A(p[0]);
      return;
    }
    if (!R && y > 2 && U && p && e) {
      A(p[e.length - 1]);
      return;
    }
    const _ = p?.reduce((P, K) => typeof P != "number" || typeof K != "number" ? P : Math.abs(K - N) < Math.abs(P - N) ? K : P), z = O(h) ? window.innerHeight : window.innerWidth;
    if (y > re && Math.abs(u) < z * 0.4) {
      const P = U ? 1 : -1;
      if (P > 0 && k && e) {
        A(p[e.length - 1]);
        return;
      }
      if (l && P < 0 && I && b(), E === null) return;
      A(p[E + P]);
      return;
    }
    A(_);
  }
  function q({ draggedDistance: u }) {
    if (M === null) return;
    const b = h === "bottom" || h === "right" ? M - u : M + u;
    (h === "bottom" || h === "right") && b < p[p.length - 1] || (h === "top" || h === "left") && b > p[p.length - 1] || $(r.current, {
      transform: O(h) ? `translate3d(0, ${b}px, 0)` : `translate3d(${b}px, 0, 0)`
    });
  }
  function Z(u, b) {
    if (!e || typeof E != "number" || !p || a === void 0) return null;
    const y = E === a - 1;
    if (E >= a && b)
      return 0;
    if (y && !b) return 1;
    if (!F && !y) return null;
    const N = y ? E + 1 : E - 1, W = y ? p[N] - p[N - 1] : p[N + 1] - p[N], l = u / Math.abs(W);
    return y ? 1 - l : l;
  }
  return {
    isLastSnapPoint: k,
    activeSnapPoint: g,
    shouldFade: F,
    getPercentageDragged: Z,
    setActiveSnapPoint: m,
    activeSnapPointIndex: E,
    onRelease: c,
    onDrag: q,
    snapPointsOffset: p
  };
}
const rn = () => () => {
};
function an() {
  const { direction: t, isOpen: n, shouldScaleBackground: e, setBackgroundColorOnScale: r, noBodyStyles: i } = wt(), a = o.useRef(null), f = Gt(() => document.body.style.backgroundColor, []);
  function h() {
    return (window.innerWidth - At) / window.innerWidth;
  }
  o.useEffect(() => {
    if (n && e) {
      a.current && clearTimeout(a.current);
      const S = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!S) return;
      Qe(r && !i ? Ct(document.body, {
        background: "black"
      }) : rn, Ct(S, {
        transformOrigin: O(t) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${x.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${x.EASE.join(",")})`
      }));
      const R = Ct(S, {
        borderRadius: `${ae}px`,
        overflow: "hidden",
        ...O(t) ? {
          transform: `scale(${h()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${h()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        R(), a.current = window.setTimeout(() => {
          f ? document.body.style.background = f : document.body.style.removeProperty("background");
        }, x.DURATION * 1e3);
      };
    }
  }, [
    n,
    e,
    f
  ]);
}
let ft = null;
function on({ isOpen: t, modal: n, nested: e, hasBeenOpened: r, preventScrollRestoration: i, noBodyStyles: a }) {
  const [f, h] = o.useState(() => typeof window < "u" ? window.location.href : ""), S = o.useRef(0), R = o.useCallback(() => {
    if (Vt() && ft === null && t && !a) {
      ft = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: m, innerHeight: w } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-S.current}px`,
        left: `${-m}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const j = w - window.innerHeight;
        j && S.current >= w && (document.body.style.top = `${-(S.current + j)}px`);
      }), 300);
    }
  }, [
    t
  ]), g = o.useCallback(() => {
    if (Vt() && ft !== null && !a) {
      const m = -parseInt(document.body.style.top, 10), w = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, ft), window.requestAnimationFrame(() => {
        if (i && f !== window.location.href) {
          h(window.location.href);
          return;
        }
        window.scrollTo(w, m);
      }), ft = null;
    }
  }, [
    f
  ]);
  return o.useEffect(() => {
    function m() {
      S.current = window.scrollY;
    }
    return m(), window.addEventListener("scroll", m), () => {
      window.removeEventListener("scroll", m);
    };
  }, []), o.useEffect(() => {
    if (n)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || g();
      };
  }, [
    n,
    g
  ]), o.useEffect(() => {
    e || !r || (t ? (!window.matchMedia("(display-mode: standalone)").matches && R(), n || window.setTimeout(() => {
      g();
    }, 500)) : g());
  }, [
    t,
    r,
    f,
    n,
    e,
    R,
    g
  ]), {
    restorePositionSetting: g
  };
}
function sn({ open: t, onOpenChange: n, children: e, onDrag: r, onRelease: i, snapPoints: a, shouldScaleBackground: f = !1, setBackgroundColorOnScale: h = !0, closeThreshold: S = Ze, scrollLockTimeout: R = tn, dismissible: g = !0, handleOnly: m = !1, fadeFromIndex: w = a && a.length - 1, activeSnapPoint: j, setActiveSnapPoint: k, fixed: E, modal: F = !0, onClose: p, nested: M, noBodyStyles: A = !1, direction: c = "bottom", defaultOpen: q = !1, disablePreventScroll: Z = !0, snapToSequentialPoint: u = !1, preventScrollRestoration: b = !1, repositionInputs: y = !0, onAnimationEnd: I, container: N, autoFocus: W = !1 }) {
  var l, U;
  const [_ = !1, z] = ie({
    defaultProp: q,
    prop: t,
    onChange: (s) => {
      n?.(s), !s && !M && ge(), setTimeout(() => {
        I?.(s);
      }, x.DURATION * 1e3), s && !F && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), s || (document.body.style.pointerEvents = "auto");
    }
  }), [P, K] = o.useState(!1), [G, it] = o.useState(!1), [de, _t] = o.useState(!1), rt = o.useRef(null), pt = o.useRef(null), bt = o.useRef(null), Dt = o.useRef(null), st = o.useRef(null), lt = o.useRef(!1), St = o.useRef(null), Tt = o.useRef(0), at = o.useRef(!1), Ht = o.useRef(!q), kt = o.useRef(0), d = o.useRef(null), Lt = o.useRef(((l = d.current) == null ? void 0 : l.getBoundingClientRect().height) || 0), Bt = o.useRef(((U = d.current) == null ? void 0 : U.getBoundingClientRect().width) || 0), Rt = o.useRef(0), fe = o.useCallback((s) => {
    a && s === ut.length - 1 && (pt.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: me, activeSnapPointIndex: ot, setActiveSnapPoint: jt, onRelease: we, snapPointsOffset: ut, onDrag: pe, shouldFade: Ft, getPercentageDragged: he } = nn({
    snapPoints: a,
    activeSnapPointProp: j,
    setActiveSnapPointProp: k,
    drawerRef: d,
    fadeFromIndex: w,
    overlayRef: rt,
    onSnapPointChange: fe,
    direction: c,
    container: N,
    snapToSequentialPoint: u
  });
  Ve({
    isDisabled: !_ || G || !F || de || !P || !y || !Z
  });
  const { restorePositionSetting: ge } = on({
    isOpen: _,
    modal: F,
    nested: M ?? !1,
    hasBeenOpened: P,
    preventScrollRestoration: b,
    noBodyStyles: A
  });
  function ht() {
    return (window.innerWidth - At) / window.innerWidth;
  }
  function ve(s) {
    var D, T;
    !g && !a || d.current && !d.current.contains(s.target) || (Lt.current = ((D = d.current) == null ? void 0 : D.getBoundingClientRect().height) || 0, Bt.current = ((T = d.current) == null ? void 0 : T.getBoundingClientRect().width) || 0, it(!0), bt.current = /* @__PURE__ */ new Date(), Zt() && window.addEventListener("touchend", () => lt.current = !1, {
      once: !0
    }), s.target.setPointerCapture(s.pointerId), Tt.current = O(c) ? s.pageY : s.pageX);
  }
  function Ut(s, D) {
    var T;
    let v = s;
    const C = (T = window.getSelection()) == null ? void 0 : T.toString(), L = d.current ? yt(d.current, c) : null, H = /* @__PURE__ */ new Date();
    if (v.tagName === "SELECT" || v.hasAttribute("data-vaul-no-drag") || v.closest("[data-vaul-no-drag]"))
      return !1;
    if (c === "right" || c === "left")
      return !0;
    if (pt.current && H.getTime() - pt.current.getTime() < 500)
      return !1;
    if (L !== null && (c === "bottom" ? L > 0 : L < 0))
      return !0;
    if (C && C.length > 0)
      return !1;
    if (st.current && H.getTime() - st.current.getTime() < R && L === 0 || D)
      return st.current = H, !1;
    for (; v; ) {
      if (v.scrollHeight > v.clientHeight) {
        if (v.scrollTop !== 0)
          return st.current = /* @__PURE__ */ new Date(), !1;
        if (v.getAttribute("role") === "dialog")
          return !0;
      }
      v = v.parentNode;
    }
    return !0;
  }
  function ye(s) {
    if (d.current && G) {
      const D = c === "bottom" || c === "right" ? 1 : -1, T = (Tt.current - (O(c) ? s.pageY : s.pageX)) * D, v = T > 0, C = a && !g && !v;
      if (C && ot === 0) return;
      const L = Math.abs(T), H = document.querySelector("[data-vaul-drawer-wrapper]"), J = c === "bottom" || c === "top" ? Lt.current : Bt.current;
      let Y = L / J;
      const tt = he(L, v);
      if (tt !== null && (Y = tt), C && Y >= 1 || !lt.current && !Ut(s.target, v)) return;
      if (d.current.classList.add(Ot), lt.current = !0, $(d.current, {
        transition: "none"
      }), $(rt.current, {
        transition: "none"
      }), a && pe({
        draggedDistance: T
      }), v && !a) {
        const X = Je(T), gt = Math.min(X * -1, 0) * D;
        $(d.current, {
          transform: O(c) ? `translate3d(0, ${gt}px, 0)` : `translate3d(${gt}px, 0, 0)`
        });
        return;
      }
      const Q = 1 - Y;
      if ((Ft || w && ot === w - 1) && (r?.(s, Y), $(rt.current, {
        opacity: `${Q}`,
        transition: "none"
      }, !0)), H && rt.current && f) {
        const X = Math.min(ht() + Y * (1 - ht()), 1), gt = 8 - Y * 8, zt = Math.max(0, 14 - Y * 14);
        $(H, {
          borderRadius: `${gt}px`,
          transform: O(c) ? `scale(${X}) translate3d(0, ${zt}px, 0)` : `scale(${X}) translate3d(${zt}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const X = L * D;
        $(d.current, {
          transform: O(c) ? `translate3d(0, ${X}px, 0)` : `translate3d(${X}px, 0, 0)`
        });
      }
    }
  }
  o.useEffect(() => {
    window.requestAnimationFrame(() => {
      Ht.current = !0;
    });
  }, []), o.useEffect(() => {
    var s;
    function D() {
      if (!d.current || !y) return;
      const T = document.activeElement;
      if ($_t(T) || at.current) {
        var v;
        const C = ((v = window.visualViewport) == null ? void 0 : v.height) || 0, L = window.innerHeight;
        let H = L - C;
        const J = d.current.getBoundingClientRect().height || 0, Y = J > L * 0.8;
        Rt.current || (Rt.current = J);
        const tt = d.current.getBoundingClientRect().top;
        if (Math.abs(kt.current - H) > 60 && (at.current = !at.current), a && a.length > 0 && ut && ot) {
          const Q = ut[ot] || 0;
          H += Q;
        }
        if (kt.current = H, J > C || at.current) {
          const Q = d.current.getBoundingClientRect().height;
          let X = Q;
          Q > C && (X = C - (Y ? tt : At)), E ? d.current.style.height = `${Q - Math.max(H, 0)}px` : d.current.style.height = `${Math.max(X, C - tt)}px`;
        } else Le() || (d.current.style.height = `${Rt.current}px`);
        a && a.length > 0 && !at.current ? d.current.style.bottom = "0px" : d.current.style.bottom = `${Math.max(H, 0)}px`;
      }
    }
    return (s = window.visualViewport) == null || s.addEventListener("resize", D), () => {
      var T;
      return (T = window.visualViewport) == null ? void 0 : T.removeEventListener("resize", D);
    };
  }, [
    ot,
    a,
    ut
  ]);
  function ct(s) {
    be(), p?.(), s || z(!1), setTimeout(() => {
      a && jt(a[0]);
    }, x.DURATION * 1e3);
  }
  function Wt() {
    if (!d.current) return;
    const s = document.querySelector("[data-vaul-drawer-wrapper]"), D = yt(d.current, c);
    $(d.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`
    }), $(rt.current, {
      transition: `opacity ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`,
      opacity: "1"
    }), f && D && D > 0 && _ && $(s, {
      borderRadius: `${ae}px`,
      overflow: "hidden",
      ...O(c) ? {
        transform: `scale(${ht()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${ht()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${x.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${x.EASE.join(",")})`
    }, !0);
  }
  function be() {
    !G || !d.current || (d.current.classList.remove(Ot), lt.current = !1, it(!1), Dt.current = /* @__PURE__ */ new Date());
  }
  function De(s) {
    if (!G || !d.current) return;
    d.current.classList.remove(Ot), lt.current = !1, it(!1), Dt.current = /* @__PURE__ */ new Date();
    const D = yt(d.current, c);
    if (!s || !Ut(s.target, !1) || !D || Number.isNaN(D) || bt.current === null) return;
    const T = Dt.current.getTime() - bt.current.getTime(), v = Tt.current - (O(c) ? s.pageY : s.pageX), C = Math.abs(v) / T;
    if (C > 0.05 && (_t(!0), setTimeout(() => {
      _t(!1);
    }, 200)), a) {
      we({
        draggedDistance: v * (c === "bottom" || c === "right" ? 1 : -1),
        closeDrawer: ct,
        velocity: C,
        dismissible: g
      }), i?.(s, !0);
      return;
    }
    if (c === "bottom" || c === "right" ? v > 0 : v < 0) {
      Wt(), i?.(s, !0);
      return;
    }
    if (C > re) {
      ct(), i?.(s, !1);
      return;
    }
    var L;
    const H = Math.min((L = d.current.getBoundingClientRect().height) != null ? L : 0, window.innerHeight);
    var J;
    const Y = Math.min((J = d.current.getBoundingClientRect().width) != null ? J : 0, window.innerWidth), tt = c === "left" || c === "right";
    if (Math.abs(D) >= (tt ? Y : H) * S) {
      ct(), i?.(s, !1);
      return;
    }
    i?.(s, !0), Wt();
  }
  o.useEffect(() => (_ && ($(document.documentElement, {
    scrollBehavior: "auto"
  }), pt.current = /* @__PURE__ */ new Date()), () => {
    Ge(document.documentElement, "scrollBehavior");
  }), [
    _
  ]);
  function Se(s) {
    const D = s ? (window.innerWidth - et) / window.innerWidth : 1, T = s ? -et : 0;
    St.current && window.clearTimeout(St.current), $(d.current, {
      transition: `transform ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`,
      transform: O(c) ? `scale(${D}) translate3d(0, ${T}px, 0)` : `scale(${D}) translate3d(${T}px, 0, 0)`
    }), !s && d.current && (St.current = setTimeout(() => {
      const v = yt(d.current, c);
      $(d.current, {
        transition: "none",
        transform: O(c) ? `translate3d(0, ${v}px, 0)` : `translate3d(${v}px, 0, 0)`
      });
    }, 500));
  }
  function Te(s, D) {
    if (D < 0) return;
    const T = (window.innerWidth - et) / window.innerWidth, v = T + D * (1 - T), C = -et + D * et;
    $(d.current, {
      transform: O(c) ? `scale(${v}) translate3d(0, ${C}px, 0)` : `scale(${v}) translate3d(${C}px, 0, 0)`,
      transition: "none"
    });
  }
  function Re(s, D) {
    const T = O(c) ? window.innerHeight : window.innerWidth, v = D ? (T - et) / T : 1, C = D ? -et : 0;
    D && $(d.current, {
      transition: `transform ${x.DURATION}s cubic-bezier(${x.EASE.join(",")})`,
      transform: O(c) ? `scale(${v}) translate3d(0, ${C}px, 0)` : `scale(${v}) translate3d(${C}px, 0, 0)`
    });
  }
  return o.useEffect(() => {
    F || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    F
  ]), /* @__PURE__ */ o.createElement(Pe, {
    defaultOpen: q,
    onOpenChange: (s) => {
      !g && !s || (s ? K(!0) : ct(!0), z(s));
    },
    open: _
  }, /* @__PURE__ */ o.createElement(Qt.Provider, {
    value: {
      activeSnapPoint: me,
      snapPoints: a,
      setActiveSnapPoint: jt,
      drawerRef: d,
      overlayRef: rt,
      onOpenChange: n,
      onPress: ve,
      onRelease: De,
      onDrag: ye,
      dismissible: g,
      shouldAnimate: Ht,
      handleOnly: m,
      isOpen: _,
      isDragging: G,
      shouldFade: Ft,
      closeDrawer: ct,
      onNestedDrag: Te,
      onNestedOpenChange: Se,
      onNestedRelease: Re,
      keyboardIsOpen: at,
      modal: F,
      snapPointsOffset: ut,
      activeSnapPointIndex: ot,
      direction: c,
      shouldScaleBackground: f,
      setBackgroundColorOnScale: h,
      noBodyStyles: A,
      container: N,
      autoFocus: W
    }
  }, e));
}
const se = /* @__PURE__ */ o.forwardRef(function({ ...t }, n) {
  const { overlayRef: e, snapPoints: r, onRelease: i, shouldFade: a, isOpen: f, modal: h, shouldAnimate: S } = wt(), R = ee(n, e), g = r && r.length > 0;
  if (!h)
    return null;
  const m = o.useCallback((w) => i(w), [
    i
  ]);
  return /* @__PURE__ */ o.createElement(_e, {
    onMouseUp: m,
    ref: R,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": f && g ? "true" : "false",
    "data-vaul-snap-points-overlay": f && a ? "true" : "false",
    "data-vaul-animate": S?.current ? "true" : "false",
    ...t
  });
});
se.displayName = "Drawer.Overlay";
const le = /* @__PURE__ */ o.forwardRef(function({ onPointerDownOutside: t, style: n, onOpenAutoFocus: e, ...r }, i) {
  const { drawerRef: a, onPress: f, onRelease: h, onDrag: S, keyboardIsOpen: R, snapPointsOffset: g, activeSnapPointIndex: m, modal: w, isOpen: j, direction: k, snapPoints: E, container: F, handleOnly: p, shouldAnimate: M, autoFocus: A } = wt(), [c, q] = o.useState(!1), Z = ee(i, a), u = o.useRef(null), b = o.useRef(null), y = o.useRef(!1), I = E && E.length > 0;
  an();
  const N = (l, U, _ = 0) => {
    if (y.current) return !0;
    const z = Math.abs(l.y), P = Math.abs(l.x), K = P > z, G = [
      "bottom",
      "right"
    ].includes(U) ? 1 : -1;
    if (U === "left" || U === "right") {
      if (!(l.x * G < 0) && P >= 0 && P <= _)
        return K;
    } else if (!(l.y * G < 0) && z >= 0 && z <= _)
      return !K;
    return y.current = !0, !0;
  };
  o.useEffect(() => {
    I && window.requestAnimationFrame(() => {
      q(!0);
    });
  }, []);
  function W(l) {
    u.current = null, y.current = !1, h(l);
  }
  return /* @__PURE__ */ o.createElement(Ie, {
    "data-vaul-drawer-direction": k,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": c ? "true" : "false",
    "data-vaul-snap-points": j && I ? "true" : "false",
    "data-vaul-custom-container": F ? "true" : "false",
    "data-vaul-animate": M?.current ? "true" : "false",
    ...r,
    ref: Z,
    style: g && g.length > 0 ? {
      "--snap-point-height": `${g[m ?? 0]}px`,
      ...n
    } : n,
    onPointerDown: (l) => {
      p || (r.onPointerDown == null || r.onPointerDown.call(r, l), u.current = {
        x: l.pageX,
        y: l.pageY
      }, f(l));
    },
    onOpenAutoFocus: (l) => {
      e?.(l), A || l.preventDefault();
    },
    onPointerDownOutside: (l) => {
      if (t?.(l), !w || l.defaultPrevented) {
        l.preventDefault();
        return;
      }
      R.current && (R.current = !1);
    },
    onFocusOutside: (l) => {
      if (!w) {
        l.preventDefault();
        return;
      }
    },
    onPointerMove: (l) => {
      if (b.current = l, p || (r.onPointerMove == null || r.onPointerMove.call(r, l), !u.current)) return;
      const U = l.pageY - u.current.y, _ = l.pageX - u.current.x, z = l.pointerType === "touch" ? 10 : 2;
      N({
        x: _,
        y: U
      }, k, z) ? S(l) : (Math.abs(_) > z || Math.abs(U) > z) && (u.current = null);
    },
    onPointerUp: (l) => {
      r.onPointerUp == null || r.onPointerUp.call(r, l), u.current = null, y.current = !1, h(l);
    },
    onPointerOut: (l) => {
      r.onPointerOut == null || r.onPointerOut.call(r, l), W(b.current);
    },
    onContextMenu: (l) => {
      r.onContextMenu == null || r.onContextMenu.call(r, l), b.current && W(b.current);
    }
  });
});
le.displayName = "Drawer.Content";
const ln = 250, un = 120, cn = /* @__PURE__ */ o.forwardRef(function({ preventCycle: t = !1, children: n, ...e }, r) {
  const { closeDrawer: i, isDragging: a, snapPoints: f, activeSnapPoint: h, setActiveSnapPoint: S, dismissible: R, handleOnly: g, isOpen: m, onPress: w, onDrag: j } = wt(), k = o.useRef(null), E = o.useRef(!1);
  function F() {
    if (E.current) {
      A();
      return;
    }
    window.setTimeout(() => {
      p();
    }, un);
  }
  function p() {
    if (a || t || E.current) {
      A();
      return;
    }
    if (A(), !f || f.length === 0) {
      R || i();
      return;
    }
    if (h === f[f.length - 1] && R) {
      i();
      return;
    }
    const q = f.findIndex((u) => u === h);
    if (q === -1) return;
    const Z = f[q + 1];
    S(Z);
  }
  function M() {
    k.current = window.setTimeout(() => {
      E.current = !0;
    }, ln);
  }
  function A() {
    k.current && window.clearTimeout(k.current), E.current = !1;
  }
  return /* @__PURE__ */ o.createElement("div", {
    onClick: F,
    onPointerCancel: A,
    onPointerDown: (c) => {
      g && w(c), M();
    },
    onPointerMove: (c) => {
      g && j(c);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": m ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...e
  }, /* @__PURE__ */ o.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, n));
});
cn.displayName = "Drawer.Handle";
function dn(t) {
  const n = wt(), { container: e = n.container, ...r } = t;
  return /* @__PURE__ */ o.createElement(Me, {
    container: e,
    ...r
  });
}
const V = {
  Root: sn,
  Content: le,
  Overlay: se,
  Trigger: Oe,
  Portal: dn,
  Close: $e,
  Title: Ne,
  Description: Ae
}, fn = Jt(void 0), Pt = () => {
  const t = Mt(fn);
  return t || null;
}, It = Jt({
  id: ""
}), mn = ({
  shouldScaleBackground: t = !0,
  ...n
}) => {
  const e = Pt(), r = Gt(() => Math.random().toString(36).substring(2, 15), []), [i, a] = Ce(n.open ?? !1);
  return Kt(() => {
    a(n.open ?? !1);
  }, [n.open]), /* @__PURE__ */ B.jsx(It.Provider, { value: {
    id: r
  }, children: /* @__PURE__ */ B.jsx(V.Root, { shouldScaleBackground: t, ...n, open: i, onOpenChange: (f) => {
    n.onOpenChange ? n.onOpenChange(f) : a(f), e && (f ? e.openDrawer(r) : e.drawerStack.length > 1 && !e.clearAllOnClose && e.closeDrawer(r));
  }, onAnimationEnd: (f) => {
    e && !f && (e.drawerStack.length === 1 || e.clearAllOnClose) && e.closeDrawer(r);
  } }) });
};
mn.displayName = "Drawer";
const Rn = V.Trigger, wn = V.Portal, ue = mt(({
  className: t,
  children: n,
  ...e
}, r) => /* @__PURE__ */ B.jsx(V.Close, { className: t, ref: r, ...e, children: n }));
ue.displayName = V.Close.displayName;
const ce = mt(({
  className: t,
  ...n
}, e) => {
  const {
    id: r
  } = Mt(It), i = Pt(), a = i?.isBottomDrawer(r);
  return /* @__PURE__ */ B.jsx(V.Overlay, { ref: e, className: nt("tw-fixed tw-inset-0 tw-bg-overlay-dark tw-z-[1031]", {
    "!tw-opacity-0": !!i && !a
  }, t), ...n });
});
ce.displayName = V.Overlay.displayName;
const pn = mt(({
  className: t,
  children: n,
  ...e
}, r) => {
  const {
    id: i
  } = Mt(It), a = Pt(), f = a?.isTopDrawer(i);
  return /* @__PURE__ */ B.jsxs(wn, { children: [
    /* @__PURE__ */ B.jsx(ce, {}),
    /* @__PURE__ */ B.jsx(V.Content, { ref: r, className: nt("tw-fixed tw-bottom-0 tw-inset-x-0 tw-mt-24 tw-flex tw-h-auto tw-flex-col tw-rounded-t-12 tw-rounded-b-0 tw-bg-base-white tw-z-[1031]", {
      "tw-hidden": !!a && !f
    }, t), ...e, children: n })
  ] });
});
pn.displayName = "DrawerContent";
const hn = ({
  className: t,
  children: n,
  showCloseButton: e,
  ...r
}) => /* @__PURE__ */ B.jsx("div", { className: nt("tw-border-b tw-border-gray-400 tw-p-16", t), ...r, children: /* @__PURE__ */ B.jsxs("div", { className: nt("relative", {
  "tw-pr-24": e
}), children: [
  n,
  e && /* @__PURE__ */ B.jsx(ue, { className: "tw-absolute tw-right-16 tw-top-16 tw-flex tw-items-center tw-justify-center", children: /* @__PURE__ */ B.jsx(He, {}) })
] }) });
hn.displayName = "DrawerHeader";
const gn = ({
  className: t,
  ...n
}) => /* @__PURE__ */ B.jsx("div", { className: nt("tw-py-12 tw-px-16 tw-border-t tw-border-gray-400", t), ...n });
gn.displayName = "DrawerFooter";
const vn = mt(({
  className: t,
  ...n
}, e) => /* @__PURE__ */ B.jsx(V.Title, { ref: e, className: nt("tw-headline-2-m", t), ...n }));
vn.displayName = V.Title.displayName;
const yn = mt(({
  className: t,
  ...n
}, e) => /* @__PURE__ */ B.jsx(V.Description, { ref: e, className: nt("tw-body-2 tw-text-gray-600", t), ...n }));
yn.displayName = V.Description.displayName;
export {
  fn as D,
  mn as a,
  ue as b,
  pn as c,
  yn as d,
  gn as e,
  hn as f,
  ce as g,
  wn as h,
  vn as i,
  Rn as j
};
//# sourceMappingURL=Drawer.DJSM1vCc.js.map
